exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".talk-input-wrapper {\n  display: flex; }\n\n.talk-input-raw {\n  height: 28px;\n  width: 100%;\n  padding: 4px;\n  font-size: 0.9375rem;\n  line-height: 1.9em;\n  color: #2f3136;\n  border: 1px solid rgba(145, 145, 145, 0.39);\n  resize: none; }\n  .talk-input-raw:focus {\n    outline: none;\n    border: 1px solid #51cbee; }\n  .talk-input-raw:disabled {\n    background: #FDF1C1; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./style/talk-input.scss
// module id = 45
// module chunks = 0